module.exports = __webpack_public_path__ + "img/smiles.0b37ad37.svg";